import React from "react";
import { Route, Switch } from "react-router-dom";
import { VideoHomePageList, VideoResourceList } from "..";
import { APP_ROUTES } from "../../../constants";
import { PageWithSubRoute } from "../../components";

import { ResourceRoutes } from "./ResourceRoutes";

const ResourceManagementPresenter: React.FC = (props) => {
  return (
    <>
      <PageWithSubRoute routeMenu={ResourceRoutes}>
        <Switch>
          {ResourceRoutes.map((route) => {
            return <Route key={route.path} path={route.path} exact render={route.renderComponent} />;
          })}

          {/* những route không có trong menu */}
          <Route path={APP_ROUTES.RESOURCE.VIDEO.VIDEOHOMEPAGE.DETAIL} exact component={VideoHomePageList} />
          <Route path={APP_ROUTES.RESOURCE.VIDEO.VIDEORESOURCE.DETAIL} exact component={VideoResourceList} />
        </Switch>
      </PageWithSubRoute>
    </>
  );
};

export default ResourceManagementPresenter;
